var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesejo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 7.32811L19.421 5.36278C14.933 0.74946 6.7037 2.34146 3.73304 8.14144C2.33838 10.8694 2.02371 14.8081 4.57037 19.8347C7.0237 24.6747 12.1277 30.472 21.333 36.7867C30.5383 30.472 35.6396 24.6747 38.0956 19.8347C40.6423 14.8054 40.3303 10.8694 38.9329 8.14144C35.9623 2.34146 27.733 0.746794 23.245 5.36011L21.333 7.32811ZM21.333 40C-19.5549 12.9814 8.74369 -8.10651 20.8637 3.04812C21.0237 3.19479 21.181 3.34679 21.333 3.50412C21.4834 3.34693 21.64 3.1957 21.8023 3.05079C33.9196 -8.11184 62.2209 12.9788 21.333 40Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesejo);
export default __webpack_public_path__ + "static/media/desejo.af9b35a29a8b4102a8091c067c4f6310.svg";
export { ForwardRef as ReactComponent };